<template>
	<div>
    <back :title="titlename"></back>
		<!-- banner图 -->
		<banner></banner>
    <!-- 业务类型 -->
    <div class="list">
      <div class="ywlist">
        <p>{{title}}</p>
        <ul>
          <li v-for="item in ywlist" @click="link(item.SHIXIANGID,item.QINGDAN,item.NAME)">
            <img src="../assets/images/yw_icon1.png" alt="">
            <p>{{item.NAME}}</p>
          </li>
        </ul>
        <!-- <router-link :to="{path:'/Serviceway',query:{personLX:this.ywid}}">
          <img src="../assets/images/yw_icon1.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link to="/">
          <img src="../assets/images/yw_icon2.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link to="/">
          <img src="../assets/images/yw_icon3.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link to="/">
          <img src="../assets/images/yw_icon1.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link to="/">
          <img src="../assets/images/yw_icon2.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link list-icon to="/">
          <img src="../assets/images/yw_icon3.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link to="/">
          <img src="../assets/images/yw_icon2.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link list-icon to="/">
          <img src="../assets/images/yw_icon3.png" alt="">
          <p>更多</p>
        </router-link> -->
      </div>
    </div>

		<!-- 底部 -->
		<tabbar></tabbar>
	</div>

</template>

<script>
  import {Dialog} from 'vant'
export default {
    data() {
      return {
        ywid:"",
        title:"",
        titlename:"元和街道第一窗口",
        ywlist:[]
      };
    },
    created:function(){
      this.title=this.$route.query.title
      this.ywid=this.$route.query.ywId
      this.getyelist()
    },
    methods:{
      // 业务列表
      getyelist(){
        this.$http.post(this.$store.state.host+"/interface/shixiangList",{YEWUID:this.ywid},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            this.ywlist=res.body.list
          }

          //if()
        },res=>{
           //发送失败
        })
      },
      // 业务跳转
      link(obj,content,name){
        Dialog.alert({
          title: '材料清单',
          message: content,
          messageAlign:'left'
        }).then(() => {
          this.$router.push({path:'/Serviceway',query:{sxid:obj,name:name}})
          // on close
        });

      }

    },
    mounted:function(){
      // this.personlx=this.$route.query.personLX
      // if(this.personlx==0){
      //   this.title="法人业务"
      // }
      // if(this.personlx==1){
      //   this.title="自然人业务"
      // }
    },
  };
</script>

<style lang="less" scoped>
  .list{
    padding: .4rem .35rem 0rem;
    .ywlist{
      display: flex;
      flex-wrap: wrap;
      position: relative;
      top:-1rem;
      padding: .26rem;
      font-size: .3rem;
      background: white;
      border-radius: .08rem;
      box-shadow: 0px 0px .05rem #dedede;
      >p{
        width: 100%;
        margin-bottom: .4rem;
      }
      >p::before{
        content: "";
        width: .08rem;
        background: #517be9;
        display: inline-block;
        height: .24rem;
        margin-right: .14rem;
      }

      ul{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          width: 48%;
          text-align: center;
          font-size: .24rem;
          margin-bottom: .4rem;
          img{
            width: .8rem;
            height: .8rem;
          }
          p{
            margin: 0px;
            color: #333333;
            margin-top: .12rem;
          }
        }
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/ywlist.vue